import {
  GetCityByPrefGroupedByStepAQuery,
  GetCityByPrefGroupedByStepADocument,
} from "@/generated/graphql";
import { ApolloQueryResult } from "@apollo/client/core";
import { generateApolloClient } from "../apolloClientUtil";

/**
 * 市区を取得する(読み仮名のあ段でグループ化)
 * @param customerCode カスタマーコード
 * @param chainCode チェーンコード
 * @param shopCode 店舗コード
 * @param pref 都道府県
 * @returns 市区の情報をグループごとに返す
 */
export async function getCityByPrefGroupedByStepA(
  customerCode: string,
  chainCode: string,
  shopCode: string,
  pref: string
): Promise<
  | {
      __typename?: "Kana_Step_A" | undefined;
      line_a?: (string | null | undefined)[] | null | undefined;
      line_ka?: (string | null | undefined)[] | null | undefined;
      line_sa?: (string | null | undefined)[] | null | undefined;
      line_ta?: (string | null | undefined)[] | null | undefined;
      line_na?: (string | null | undefined)[] | null | undefined;
      line_ha?: (string | null | undefined)[] | null | undefined;
      line_ma?: (string | null | undefined)[] | null | undefined;
      line_ya?: (string | null | undefined)[] | null | undefined;
      line_ra?: (string | null | undefined)[] | null | undefined;
      line_wa?: (string | null | undefined)[] | null | undefined;
      line_other?: (string | null | undefined)[] | null | undefined;
    }
  | null
  | undefined
> {
  try {
    //graphql接続
    const apolloClient = await generateApolloClient();
    const city: ApolloQueryResult<GetCityByPrefGroupedByStepAQuery> =
      await apolloClient.query<GetCityByPrefGroupedByStepAQuery>({
        query: GetCityByPrefGroupedByStepADocument,
        variables: {
          customer_code: customerCode,
          chain_code: chainCode,
          shop_code: shopCode,
          pref: pref,
        },
        fetchPolicy: "no-cache",
      });
    return city.data.getCityByPrefGroupedByStepA;
  } catch (err: unknown) {
    console.error(err);
    if (err instanceof Error) {
      err.message = "市区の情報取得に失敗しました。";
      throw err;
    } else {
      throw new Error("市区の情報取得に失敗しました。");
    }
  }
}
